import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';

export const Route = createFileRoute('/_auth/migrationdashboard')({
  beforeLoad: () => {
    if (!hasSchemaACL('weave', Permission.SYNC_APP_MANAGE_ADVANCED)) {
      return redirect({ to: '/' });
    }
    return false;
  },
  component: Outlet,
});
